import React from 'react';
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { remCalc } from '../../util/style-util';
import LeftArrowIcon from 'assets/icons/LeftArrowIcon';
import RightArrowIcon from 'assets/icons/RightArrowIcon';

type Props = {
  name: string;
  isDisabled: boolean;
  turnPage: (moveForward: boolean) => void;
  isZoom: any;
};

const PageNavButton = ({ name, isDisabled, turnPage }: Props | any) => {
  const classes = useStyles()();

  const moveForward = name === 'next';
  const ArrowIcon: any = name === 'next' ? RightArrowIcon : LeftArrowIcon; // TODO Revisit

  return (
    <Button
      disableRipple
      name={name}
      size="large"
      className={classes.pageNavButton}
      disabled={isDisabled}
      onClick={turnPage}
    >
      <ArrowIcon direction={moveForward ? 'right' : 'left'} />
    </Button>
  );
};

export default PageNavButton;

const useStyles = () =>
  makeStyles(() => ({
    pageNavButton: {
      border: 'none',
      backgroundColor: 'transparent',
      maxWidth: remCalc(80),
      transition: 'transform 100ms ease-in',
      '&:hover': {
        transform: 'scale(1.2)',
        backgroundColor: 'transparent !important'
      },
      '&:focus': {
        backgroundColor: 'transparent !important'
      },
      '&:active': {
        backgroundColor: 'transparent !important'
      }
    }
  }));
